import { jsx as _jsx } from "react/jsx-runtime";
import { BiographySection } from '../BiographySection.js';
export function BiographyTab(props) {
    const { character, canEdit } = props;
    return _jsx(BiographySection, { character: character, canEdit: canEdit });
}
//# sourceMappingURL=BiographyTab.js.map